import { render, staticRenderFns } from "./PrincipalError.vue?vue&type=template&id=909b9534&"
import script from "./PrincipalError.vue?vue&type=script&lang=js&"
export * from "./PrincipalError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports